class VariantPhotogallery {
   constructor(product_url, section_id, block_id)
   {
      this.section_id = section_id;
      this.block_id = block_id;
      this.product_url = product_url;
      this.setListeners();
   }

   setListeners = () => {
      Fancybox.bind('[data-gallery-fancybox]');
      window.addEventListener('variant-change', this.onVariantChange.bind(this));
   }

   onVariantChange = async (event) => {
      
      const variant = event.detail.variant;
      const selector = `#variant-photogallery-${this.section_id}-${this.block_id}`;
      
      try {
         const response = await fetch(`${this.product_url}?variant=${variant.id}&sections=${this.section_id}`);

         if (! response.ok) {
            throw new Error(response.statusText);
         }

         const data = await response.json();
         const html = document.createElement('div');
         html.innerHTML = Object.values(data);
         const gallery = html.querySelector(selector);
         if ( gallery )
         {
            document.querySelector(selector).replaceWith(gallery);
         }
         
      } catch( error )
      {
         console.error(error);
      }
      
   }
}